import {
  ConnectionType,
  MarketTypeEnum,
  notEmpty,
  useDynamicCallback,
  useMarketAccountsContext,
  useMarketsContext,
} from '@talos/kyoko';
import { useMemo } from 'react';

function useMarketsOfType(marketAndAccounts: string[], type: MarketTypeEnum | undefined, onlyActive: boolean) {
  const { marketsByName, isMarketConfigured } = useMarketsContext();
  const { marketAccountsByName } = useMarketAccountsContext();

  const getMarketsOfType = useDynamicCallback(
    (marketsAndAccounts: string[], type: MarketTypeEnum, onlyActive: boolean) =>
      marketsAndAccounts
        .map(market => {
          const ma = marketAccountsByName.get(market);
          const marketName = ma?.Market ?? market;
          const m = marketsByName.get(marketName);
          return m?.Type === type && (onlyActive ? m && isMarketConfigured(m, ConnectionType.MarketData) : true)
            ? marketName
            : null;
        })
        .filter(notEmpty)
        .toSorted()
  );

  return useMemo(() => {
    return type != null ? getMarketsOfType(marketAndAccounts, type, onlyActive) : marketAndAccounts;
  }, [marketAndAccounts, type, onlyActive, getMarketsOfType]);
}

export function useExchangeMarkets(marketAndAccounts: string[], onlyActive: boolean) {
  return useMarketsOfType(marketAndAccounts, MarketTypeEnum.Exchange, onlyActive);
}

export function useDealerMarkets(marketAndAccounts: string[], onlyActive: boolean) {
  return useMarketsOfType(marketAndAccounts, MarketTypeEnum.Dealer, onlyActive);
}
